module.exports = __webpack_public_path__ + "static/media/Cheque.4696a2d5.svg";